/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function l(l) {
  return "global" === l ? 1 : 2;
}

function n(l) {
  return 1 === l ? "global" : "local";
}

export { n as stringFromViewingMode, l as viewingModeFromString };